var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollarSign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 25,
    viewBox: "0 0 14 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.39728H12C12.552 4.39728 13 4.84528 13 5.39728C13 5.94928 12.552 6.39728 12 6.39728H8V11.3973H9.5C11.985 11.3973 14 13.4123 14 15.8973C14 18.3823 11.985 20.3973 9.5 20.3973H8V23.3973C8 23.9493 7.552 24.3973 7 24.3973C6.448 24.3973 6 23.9493 6 23.3973V20.3973H1C0.448 20.3973 0 19.9493 0 19.3973C0 18.8453 0.448 18.3973 1 18.3973H6V13.3973H4.5C2.015 13.3973 0 11.3823 0 8.89728C0 6.41228 2.015 4.39728 4.5 4.39728H6V1.39728C6 0.845278 6.448 0.397278 7 0.397278C7.552 0.397278 8 0.845278 8 1.39728V4.39728ZM8 13.3973V18.3973H9.5C10.881 18.3973 12 17.2783 12 15.8973C12 14.5163 10.881 13.3973 9.5 13.3973H8ZM6 11.3973V6.39728H4.5C3.119 6.39728 2 7.51628 2 8.89728C2 10.2783 3.119 11.3973 4.5 11.3973H6Z",
    fill: "#27221D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarSign);
export default __webpack_public_path__ + "static/media/dollar-sign.3031d153a9442b45c86b7b42e0178258.svg";
export { ForwardRef as ReactComponent };